<template>
  <transition name="fade">
   <div class="modal modal-mask">
    <div class="modal-dialog" role="document">
      <div class="modal-content container">
        <div class="modal-header">
          <slot name="header"></slot>
        </div>

        <div class="modal-body row" style="margin: .5rem;">
          <slot class="col-xs-12" name="body"></slot>
        </div>

        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
export default{
  props: {
    errors: {
      default: () => ({})
    }
  }
};
</script>

 <style>
.modal-mask {
 position: fixed;
 z-index: 9998;
 top: 0;
 left: 0;
 width: 100%;
 height: 100%;
 background-color: rgba(0, 0, 0, .5);
 display: block;
 transition: opacity .3s ease;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.modal-content {
  width :100%;
}
</style>
